const translations = {
    timeout: 'The request to the server timed out',
    tryAgain: 'Try again by refreshing the page.'
};

export default translations;
